document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".color-swatch").forEach((swatch) => {
        swatch.addEventListener("click", function () {
            let selectedScent = this.getAttribute("data-tooltip").toLowerCase().replace(/\s+/g, "_");

            // Find the closest product card
            let productCard = this.closest(".product-card");
            if (!productCard) return;

            // Find the matching image based on alt text
            let images = productCard.querySelectorAll(".product-card__image");
            let matchingImage = Array.from(images).find(img => {
                return img.alt.toLowerCase().includes(`#scent_${selectedScent}`);
            });

            // Update secondary image
            let secondaryImage = productCard.querySelector(".product-card__image--secondary");
            if (matchingImage && secondaryImage) {
                secondaryImage.src = matchingImage.src;
            }

            // Update product title if necessary
            let titleElement = productCard.querySelector(".product-card__title");
            if (titleElement) {
                titleElement.textContent = this.getAttribute("data-tooltip");
            }
        });
    });
});
